import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.pricePlan')
  .factory('$pricePlan', PricePlanObjectFactory);

function PricePlanObjectFactory($bringozFactory: $bringozFactory,
                                PricePlanAPI: BringozApi,
                                PricePlans_DS: DataStoreConfig) {

  function $pricePlan(id: string) {
    return $bringozFactory(id, PricePlanAPI, PricePlans_DS);
  }

  return $pricePlan;
}
